import React, { useEffect, useState } from 'react';
import './ImageViewer.css';

// A picture that opens full screen when tapped. Close it with the X button,
// by tapping the dark background or the picture, or with Escape.
function ImageViewer({ src, alt, className }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button type="button" className="image-viewer-trigger" onClick={() => setOpen(true)} aria-label={`View ${alt} full screen`}>
        <img src={src} alt={alt} className={className} />
      </button>
      {open && (
        <div className="image-viewer-overlay" role="dialog" aria-modal="true" aria-label={alt} onClick={() => setOpen(false)}>
          <button
            type="button"
            className="image-viewer-close"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            ✕
          </button>
          <img src={src} alt={alt} className="image-viewer-full" />
        </div>
      )}
    </>
  );
}

export default ImageViewer;
